/**
 * Compute next page index value given the current value.
 * If no current is provided the next page is 1.
 */
export const nextPageIndex = current => (current ? current + 1 : 1);

/**
 * Compute previous page index. If no current value is provided then the previous
 * page index must be 1.
 * Ensure we do not return a negative number.
 */
export const previousPageIndex = current => {
  const numPage = current ? current - 1 : 1;
  return Math.max(numPage, 1);
};

/**
 * Include page number to text passed
 */
export const addPageNumber = (text, page, intl) =>
  typeof page === 'number' && page > 1
    ? `${text} - ${intl.formatMessage({ id: 'global_wm_page' })} ${String(page)}`
    : text;



// WEBPACK FOOTER //
// ./app/utils/page.js